import { fetcher } from "helpers/fetcher";

import {
  TGetBUScorecardHistoryCorporationReq,
  TGetBUScorecardHistoryCorporationRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUScorecardHistoryCorporation = async (
  payload: TGetBUScorecardHistoryCorporationReq,
  language: string
) => {
  return await fetcher<
    TGetBUScorecardHistoryCorporationRes,
    TGetBUScorecardHistoryCorporationReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_BU_SCORECARD_HISTORY_CORPORATION, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.GET_BU_SCORECARD_HISTORY_CORPORATION.version,
      [API_HEADER.BU_ID]: payload.idBu,
      [API_HEADER.LANGUAGE]: language,
    },
    data: payload.data,
  });
};

export const queryGetBUScorecardHistoryCorporation = async (
  payload: TGetBUScorecardHistoryCorporationReq,
  language: string
) => {
  return (await getBUScorecardHistoryCorporation(payload, language)).data;
};

queryGetBUScorecardHistoryCorporation._key = (
  payload: TGetBUScorecardHistoryCorporationReq,
  language: string
) => [
  ENDPOINT.MANAGEMENT.GET_BU_SCORECARD_HISTORY_CORPORATION.url,
  payload,
  language,
];
